var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "line_org_tag"
  }, [_vm._l(_vm.list, function (item, index) {
    return _c('span', {
      key: index + item.name,
      staticClass: "block"
    }, [item.type === 'USER' ? _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['USER']
      }
    }) : item.type === 'ORG' ? _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['ORG']
      }
    }) : _c('Icon', {
      staticClass: "icon",
      attrs: {
        "type": _vm.identityIcon['TAG']
      }
    }), _c('span', [_vm._v(_vm._s(item.name))])], 1);
  }), _c('span', {
    staticClass: "edit",
    on: {
      "click": function ($event) {
        return _vm.$emit('change');
      }
    }
  }, [_vm._v($t("mekb2", "编辑"))])], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };